import MyLocationIcon from '@mui/icons-material/MyLocation';
import {Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {setExtent as setMapExtent} from '../actions/map.js';
import {getSelectedMosaic} from '../selectors/index.js';
import MapButton from './map-button.jsx';

const ZoomToMosaic = ({mosaic, setMapExtent}) => {
  const handleClick = () => setMapExtent(mosaic.bbox);

  return (
    <Tooltip title="Zoom to basemap" placement="left">
      <span>
        <MapButton
          data-qe="zoom-out-to-world-tool"
          disabled={!mosaic}
          onClick={handleClick}
        >
          <MyLocationIcon />
        </MapButton>
      </span>
    </Tooltip>
  );
};

ZoomToMosaic.propTypes = {
  setMapExtent: PropTypes.func.isRequired,
  mosaic: PropTypes.object,
};

const mapDispatchToProps = {setMapExtent};

const mapStateToProps = state => ({
  mosaic: getSelectedMosaic(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZoomToMosaic);
